/**
 * Parses a locale string (e.g. 'en-nl', 'hu-hu') into language and country parts.
 * Use this instead of duplicating locale.split('-') across the codebase.
 *
 * @param locale - Full locale string (language-country, e.g. 'en-nl')
 * @returns Object with language and country (empty string if missing)
 */
export default function parseLocale(locale: string): {
  language: string;
  country: string;
} {
  const [language = '', country = ''] = locale.split('-');
  return { language, country };
}
